import { TrustLabelPeriod } from '../../../../../components-library/labels/TrustLabel';

export default {
  labels: {
    [TrustLabelPeriod.LESS_THAN_1_MONTH]: 'Meer dan +100 klanten hebben al veilig bij ons besteld',
    [TrustLabelPeriod.ONE_MONTH_OR_MORE]: 'Meer dan +1.000 klanten hebben al veilig bij ons besteld',
    [TrustLabelPeriod.SIX_MONTHS_OR_MORE]: 'Meer dan +10.000 klanten hebben al veilig bij ons besteld',
  },
};
